// extracted by mini-css-extract-plugin
export default {"cookiebody":"cookiebody_cookiebody__MA3G8","listheading":"cookiebody_listheading__7+yJy"};